import React,{useState,useEffect} from 'react'
import {  ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import {AiOutlineEdit,AiOutlineDelete} from 'react-icons/ai'
import { DatePicker, Modal } from 'antd';
import moment from 'moment';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { DeleteTemplateService, GetTemplateService } from '../../../services/TemplateServices';
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'


function TemplateList() {


    const [data,setdata] = useState({})
    const [selecteddata,setselecteddata] = useState({})
    const [modal, setModal] = useState(false);
    const [page,setpage] = useState(1)
    
    const navigate = useNavigate()
    const [search, setsearch] = useState({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false })


    // console.log("data",data?.filter((f)=>f?.full_data !== undefined))

  
    useEffect(()=>{
        getTemplates()
    },[page])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -40%)',
        width: 300,
        bgcolor: 'white',
        boxShadow: 4,
        p: 2,
        border:'0px solid white'
      };
    

  
  async function getTemplates(){
   const response = await GetTemplateService(page,search?.from_date1,search?.to_date1,search?.text)
   setdata(response.data)
  }  

  async function deleteTemplate(){
    const response = await DeleteTemplateService(selecteddata._id)
    if(response.status === 200){
        setModal(false)
        toast.success("Data Deleted Successfully!")
        getTemplates()
    }
  }

  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetTemplateService(1, search?.from_date1, search?.to_date1,'')
    setdata(response?.data)
  }

  async function resetFilter() {
    setsearch({ ...search,text:'',from_date:'',to_date:'',from_date1:'',to_date1:'', activate: true })
    setpage(1)
    const response = await GetTemplateService(1, '', '','')
    setdata(response?.data)
  }

  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
   
     <Modal
        keepMounted
        open={modal}
        onClose={()=>setModal(false)}
        width={300}
        footer={false}
        closable={false}
       
      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            {/* <div className='mr-1 w-full'> */}
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setModal(false)} />
            {/* </div> */}
            <div  className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Confirm'} onClick={()=>deleteTemplate()}  /> 
            </div>
          </div>
        </div>
      </Modal>
        
      <div className='block sm:flex'>
        <SettingsMenu />

        <div className='md:w-[88%] px-4'>
        <div >
        <div className='pt-5'>
        <div className="flex flex-wrap justify-between align-center items-center border-b pb-2 ">
        <div className=' items-center justify-between'>
        <span className="font-[800] text-[14px]">Template Message List ({data?.pagination?.total})</span>

        <div className='flex md:hidden items-center text-[12px]'>
          <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
          <div>
            <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
          </div>
        </div>
        </div>


        <div className='flex flex-wrap items-center text-[12px]'>
          <div className='hidden md:flex items-center'>
          <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
          <div>
            <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
          </div>
          </div>

          <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

          <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

          <div className='mr-2 mt-1 md:mt-0'>
            <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
          </div>

           <div className='mr-2 mt-1 md:mt-0'>
            <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetFilter()} />
          </div>

           <div className='mr-2 mt-1 md:mt-0'>
            <ButtonFilledAutoWidth btnName="Add New" onClick={() => navigate('create')} />
          </div>

        </div> 
        </div>
        </div>


        {data?.datas?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data added based on your current page option please click on add the data button to see list here.</h6>
      </div>
       }

        {data?.datas?.length > 0 &&
        <div className='md:max-h-[85vh] md:overflow-hidden border-t border-l border-r mt-2'>
             {data?.datas?.length !== 0 &&
                   <>
                   {/* Desktop / tablet table */}
                   <div className='hidden md:block md:max-h-[85vh] md:overflow-auto'>
                   <div className='top-0 z-50 flex border-b w-full bg-white py-[-5px]  border-slate-200 relative'>
                      <h6 className='text-[12px] truncate min-w-0  w-[50px]  px-2 py-1 font-[400] border-r'>Sl No</h6>
                      <h6 className='text-[12px] truncate min-w-0 w-[120px] px-2 py-1 font-[400] border-r capitalize'>Name</h6>
                      <h6 className='text-[12px] truncate min-w-0 flex-1 px-2 py-1 font-[400] border-r capitalize'>WATI Body</h6>
                      <h6 className='text-[12px] truncate min-w-0 flex-1 px-2 py-1 font-[400] border-r capitalize'>Telinfy Body</h6>
                      <h6 className='text-[12px] truncate min-w-0 w-[120px] px-2 py-1 font-[400] border-r capitalize'>Wati Enabled</h6>
                      <h6 className='text-[12px] truncate min-w-0 w-[120px] px-2 py-1 font-[400] border-r capitalize'>Telinfy Enabled</h6>
                      <h6 className='text-[12px] truncate min-w-0  w-[120px]  px-2 py-1 font-[400] border-r capitalize'>Created On </h6>
                      <h6 className='text-[12px] truncate min-w-0  w-[50px]  px-1 py-1 font-[400] capitalize'>Action</h6>
                   </div>


                   {data?.datas?.map((d,i)=>(
                   <div key={d?._id} className='flex  w-full border-b cursor-pointer z-0'  >
                      <h6 className='text-[11px]  min-w-0 w-[50px] text-center  px-2 py-1   border-r '>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                      <h6 className='text-[11px] break-all  min-w-0 w-[120px] px-2 py-1   border-r '>
                        <b>{d?.label}</b>
                        <br></br>
                        {d?.name}
                      </h6>
                      <h6 className='text-[11px] break-all  min-w-0 flex-1 px-2 py-1   border-r '>{d?.body_wati}</h6>
                      <h6 className='text-[11px] break-all  min-w-0 flex-1 px-2 py-1   border-r '>{d?.body_telinfy}</h6>
                      <h6 className='text-[10px]  min-w-0 w-[120px]  px-2 py-1 truncate  border-r '>{!d?.wati_enabled ? <BiCheckbox size={16} className='text-gray-400'  /> : <BiCheckboxSquare size={16} className='text-slate-600' />}</h6>
                      <h6 className='text-[10px]  min-w-0 w-[120px]  px-2 py-1 truncate  border-r '>{!d?.telinfy_enabled ? <BiCheckbox size={16} className='text-gray-400'  /> : <BiCheckboxSquare size={16} className='text-slate-600' />}</h6>
                      <h6 className='text-[10px]  min-w-0 w-[120px]  px-2 py-1 truncate  border-r '>{moment(d?.createdAt).format('ll')}</h6>
                      <h6  className='text-[12px] truncate min-w-0 w-[40px] flex mt-2 justify-center '>
                        <AiOutlineEdit size={12} className="z-10 cursor-pointer" onClick={()=>{navigate('edit',{state:d})}} />
                        <AiOutlineDelete size={12} className="ml-2 z-10 cursor-pointer" onClick={()=>{setselecteddata(d);setModal(true)}}/>
                      </h6>
                   </div>))}
                   </div>

                   {/* Mobile card list */}
                   <div className='md:hidden space-y-2'>
                     {data?.datas?.map((d,i)=>(
                       <div key={d?._id} className='border rounded-md p-3 bg-white'>
                         <div className='flex items-start justify-between'>
                           <div>
                             <h6 className='text-[13px] font-[700]'>{d?.label}</h6>
                             <h6 className='text-[11px] text-slate-600'>{d?.name}</h6>
                           </div>
                           <div className='flex items-center -mr-1.5'>
                             <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={()=>{navigate('edit',{state:d})}} /></span>
                             <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={()=>{setselecteddata(d);setModal(true)}}/></span>
                           </div>
                         </div>
                         {d?.body_wati && <h6 className='text-[11px] mt-2'><span className='font-[600]'>WATI Body:</span> {d?.body_wati}</h6>}
                         {d?.body_telinfy && <h6 className='text-[11px] mt-1'><span className='font-[600]'>Telinfy Body:</span> {d?.body_telinfy}</h6>}
                         <div className='flex items-center gap-4 mt-2 text-[11px]'>
                           <span className='flex items-center'>{!d?.wati_enabled ? <BiCheckbox size={16} className='text-gray-400'  /> : <BiCheckboxSquare size={16} className='text-slate-600' />} Wati</span>
                           <span className='flex items-center'>{!d?.telinfy_enabled ? <BiCheckbox size={16} className='text-gray-400'  /> : <BiCheckboxSquare size={16} className='text-slate-600' />} Telinfy</span>
                         </div>
                         <h6 className='text-[10px] text-slate-400 mt-2'>{moment(d?.createdAt).format('ll')}</h6>
                       </div>
                     ))}
                   </div>
                   </>}
        </div>}
          </div>
        </div>
      </div> 
    </div>
  )
}

export default TemplateList